import React from "react";
import { CATEGORY_LABEL } from "./utils";

// Small inline clock for the OPENS IN xD pill — the KPI ClockIcon is a
// 32x32 card-sized element, too big for a pill, so we use a 12x12 here.
const SmallClock = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export function CategoryBadge({ category }) {
  return (
    <span
      className="inline-flex items-center px-3 py-1 rounded-full text-[13px] whitespace-nowrap"
      style={{
        background: "rgba(21, 93, 252, 0.05)",
        color: "#0039B7",
        letterSpacing: "-0.15px",
      }}
    >
      {CATEGORY_LABEL[category] || "Men's Pro"}
    </span>
  );
}

export function StatusPill({ primary, fallbackLine }) {
  const base =
    "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[11px] font-medium tracking-wider whitespace-nowrap";
  if (!primary) {
    return (
      <span className={`${base} bg-slate-100 text-slate-600`}>
        {(fallbackLine || "No data").toUpperCase()}
      </span>
    );
  }
  if (primary.state === "open") {
    const ending = primary.days <= 3;
    if (ending) {
      return (
        <span className={`${base} bg-red-50 text-red-700`}>
          <span className="w-1.5 h-1.5 rounded-full bg-current" />
          CLOSES IN {primary.days}D
        </span>
      );
    }
    return (
      <span className={`${base} bg-emerald-50 text-emerald-700`}>
        <span className="w-1.5 h-1.5 rounded-full bg-current" />
        OPEN NOW
      </span>
    );
  }
  if (primary.state === "opens") {
    return (
      <span
        className={`${base}`}
        style={{ background: "#FFEDD4", color: "#CA3500" }}
      >
        <SmallClock />
        OPENS IN {primary.days}D
      </span>
    );
  }
  // Closed window: a compact, muted "CLOSED" pill. When we have a (rough)
  // next-window estimate, append it as a small, lighter secondary hint —
  // intentionally modest, never a dominant banner. (The estimate only shows
  // because current-season windows aren't loaded; see expectedFromClosed.)
  return (
    <span className={`${base} bg-slate-100 text-slate-600`}>
      CLOSED
      {fallbackLine && (
        <span className="font-normal normal-case tracking-normal text-slate-400">
          · next {fallbackLine}
        </span>
      )}
    </span>
  );
}
